import { KYMW1002Model } from '../kymw1002.model';
import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ユーザ取引先コード一覧を取得するサービス
 *
 * @export GetUserSupplierCodeListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetUserSupplierCodeListService extends PlessJsonResponderSub<string> {

 // 処理に使用するModel
  public model: KYMW1002Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetUserSupplierCodeListService
   */
  private successFunc: Function;

  /**
   * API呼び出し
   * @memberof GetUserSupplierCodeListService
   * @param successFunc 
   */
  execute(successFunc: Function): void {
    this.successFunc = successFunc;
    this.send('getUserSupplierCodeList', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetUserSupplierCodeListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}

